import {
  ADMIN_LOG_ACTOR_SCOPES,
  normalizeAdminLogActorScope,
} from "@/lib/adminLogActorScopes";
import {
  encodeBase64Url,
  encodeTranslatedTabTitle,
  decodeBase64Url,
  trimToNull,
} from "@/lib/tabs/registryCore";

const sortStrings = (values = []) =>
  [...values].map(String).sort((left, right) => left.localeCompare(right));

export const normalizeAdminLogsParams = (params = {}) => {
  const normalized = {
    search: trimToNull(params.search) || "",
    timestampFrom: trimToNull(params.timestampFrom),
    timestampTo: trimToNull(params.timestampTo),
    sources: sortStrings(params.sources || []),
    eventTypes: sortStrings(params.eventTypes || []),
    companyId: trimToNull(params.companyId),
    userId: trimToNull(params.userId),
    actorScope: normalizeAdminLogActorScope(params.actorScope),
  };

  if (trimToNull(params.companyName)) {
    normalized.companyName = trimToNull(params.companyName);
  }

  if (trimToNull(params.userName)) {
    normalized.userName = trimToNull(params.userName);
  }

  if (trimToNull(params.userEmail)) {
    normalized.userEmail = trimToNull(params.userEmail);
  }

  return normalized;
};

export const encodeAdminLogsState = (params = {}) => {
  const normalized = normalizeAdminLogsParams(params);
  const state = {
    search: normalized.search,
    timestampFrom: normalized.timestampFrom,
    timestampTo: normalized.timestampTo,
    sources: normalized.sources,
    eventTypes: normalized.eventTypes,
    companyId: normalized.companyId,
    userId: normalized.userId,
  };

  if (normalized.actorScope !== ADMIN_LOG_ACTOR_SCOPES.All) {
    state.actorScope = normalized.actorScope;
  }

  const hasFilters =
    state.search ||
    state.timestampFrom ||
    state.timestampTo ||
    state.sources.length > 0 ||
    state.eventTypes.length > 0 ||
    state.companyId ||
    state.userId ||
    state.actorScope;

  if (!hasFilters) return null;

  return encodeBase64Url(JSON.stringify(state));
};

export const decodeAdminLogsState = (encodedState) => {
  const decoded = decodeBase64Url(encodedState);
  if (!decoded) return {};

  try {
    return normalizeAdminLogsParams(JSON.parse(decoded));
  } catch {
    return {};
  }
};

export const getAdminLogsTabTitle = ({
  companyName = "",
  userName = "",
  userEmail = "",
} = {}) => {
  const actorLabel = trimToNull(userName) || trimToNull(userEmail);
  const companyLabel = trimToNull(companyName);

  if (companyLabel && actorLabel) {
    return encodeTranslatedTabTitle({
      key: "pages.logs.admin_tab_title.actor_company",
      params: { actorLabel, companyLabel },
    });
  }

  if (companyLabel) {
    return encodeTranslatedTabTitle({
      key: "pages.logs.admin_tab_title.company",
      params: { companyLabel },
    });
  }

  if (actorLabel) {
    return encodeTranslatedTabTitle({
      key: "pages.logs.admin_tab_title.actor",
      params: { actorLabel },
    });
  }

  return "tabs.logs";
};
